// extracted by mini-css-extract-plugin
export default {"shell":"AppLayout_shell__LDTjx","main":"AppLayout_main__nBm6m","content":"AppLayout_content__EuCa8","navScrim":"AppLayout_navScrim__VmM1c"};